<template>
  <div class="video-uploaded">
    <AppWithLoading v-slot:default="{loader}">
      <div class="video-uploaded__description">
        {{ $t('description') }}
      </div>
      <div>
        <div v-if="loading" class="video-uploaded__progress">
          <span class="video-uploaded__progress-text">{{ uploadPercentage }}%</span>
          <div class="video-uploaded__progress-fill" :style="`width:${uploadPercentage}%`" />
        </div>
      </div>
      <VTextField
        v-if="false"
        v-model="url"
        :label="$t('url')"
        solo
      />

      <div class="d-flex justify-center align-center body-2" v-if="false">
        <span
          :class="{
            'grey--text lighten-2--text': (createType !== createUploadedVideoTypeEnum.FILE),
            caption: $vuetify.breakpoint.smAndDown
          }"
        >
          {{ $t('fileSwitch') }}
        </span>
        <VSwitch
          v-model="createType"
          inset
          dense
          hide-details
          success
          color="primary"
          :false-value="createUploadedVideoTypeEnum.FILE"
          :true-value="createUploadedVideoTypeEnum.LINK"
          class="ml-2 ml-md-5 mr-md-1 pt-0 primary--text interview-switch"
        />
        <span
          :class="{
            'grey--text lighten-2--text': (createType !== createUploadedVideoTypeEnum.LINK),
            caption: $vuetify.breakpoint.smAndDown
          }"
        >
          {{ $t('linkSwitch') }}
        </span>
      </div>
      <div class="video-uploaded__choice">
        <div v-if="!loading" @click="openFileCreate()" class="video-uploaded__choice-btn">
          {{ file ? $t('changeFile') :$t('selectFile') }}
        </div>
        <label v-show="false">
          <input ref="fileInput" type="file" @change="handleFileUpload( $event )" />
        </label>
        <div class="video-uploaded__input-text" v-if="file">
          <div class="video-uploaded__choiced-svg">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M13.173 0H2C0.899 0 0 0.9 0 2V14C0 15.1 0.899 16 2 16H14C15.101 16 16 15.1 16 14V3.127L13.173 0ZM12 6C12 6.549 11.55 7 11 7H5C4.45 7 4 6.549 4 6V1H12V6ZM11 2H9V6H11V2Z" fill="#B4B4B4" />
            </svg>
            <p class="video-uploaded__choiced">
              {{ $t('recordSelected') }}
            </p>
          </div>
          {{ file.name }}
        </div>
      </div>

      <template v-if="!loading">
        <VBtn
          class="mr-2"
          @click="$emit('cancel')"
        >
          {{ $t('cancel') }}
        </VBtn>
        <VBtn
          v-if="createType === createUploadedVideoTypeEnum.LINK"
          @click="loader(() => storeVideoFile())"
          :disabled="saveDisabled"
        >
          {{ $t('save') }}
        </VBtn>
        <VBtn
          v-else-if="createType === createUploadedVideoTypeEnum.FILE"
          @click="storeVideoFile()"
          :disabled="saveDisabled"
        >
          {{ $t('save') }}
        </VBtn>
      </template>
    </AppWithLoading>
  </div>
</template>

<script>
import { objectToFormData } from '@/functions';
import OfficeInterview from '@/orm/models/OfficeInterview/OfficeInterview';
import ValidationMixin from '@/mixins/ValidationMixin';
import AppWithLoading from '@/components/AppWithLoading';
import { createUploadedVideoType } from '@/enums';
import axios from 'axios';

export default {
  name: 'CreateUploadedVideoInterview',
  components: { AppWithLoading },
  mixins: [
    ValidationMixin,
  ],
  props: {
    candidate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      file: null,
      url: null,
      loading: false,
      createUploadedVideoTypeEnum: createUploadedVideoType,
      createType: createUploadedVideoType.FILE,
      uploadPercentage: 0,
    };
  },
  computed: {
    saveDisabled() {
      if (this.createType === this.createUploadedVideoTypeEnum.FILE && !this.file) {
        return true;
      }

      if (this.createType === this.createUploadedVideoTypeEnum.LINK && (!this.url || this.url === '')) {
        return true;
      }

      return false;
    },
  },
  methods: {
    openFileCreate() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async submitFile() {
      const formData = new FormData();
      formData.append('file', this.file);

      await axios.post(`/candidates/${this.candidate.id}/uploaded_video_interview`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 2 * 60 * 60 * 1000,
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100),
            );
          },
        }).then(() => {
        this.$emit('created');
      });
    },
    async storeVideoFile() {
      try {
        this.loading = true;
        if (this.file === null && this.url === null) {
          return;
        }

        if (this.file) {
          await this.submitFile();
          return;
        }

        if (this.url) {
          await this.storeUrl();
          this.$emit('created');
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        throw e;
      }
    },
    async storeUrl() {
      await this.withLoading(async () => {
        await OfficeInterview.api().storeUploadedVideo(
          this.candidate.id, this.generateData(),
        );
      }, 'videoFileLoading');
    },
    generateData() {
      if (this.file !== null) {
        return objectToFormData({ file: this.file });
      }

      if (this.url !== null) {
        return objectToFormData({ url: this.url });
      }

      return {};
    },
    cancel() {
      this.$emit('cancel');
      this.file = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-uploaded {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 23.675625rem;
  padding: 3.6875rem 1.875rem;
  background-color: #f5f5f5;
  border-radius: 0.5rem;
  text-align: center;
  &__description {
    max-width: 24.375rem;
    font-size: 1.125rem;
    line-height: 1.33;
    color: #212121;
    margin: 0 auto 1.875rem;
  }
  &__input-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #757575;
    margin-bottom: 51px;
  }
  &__choice {
    margin-bottom: 1.25rem;
  }
  &__choiced-svg {
    display: flex;
    justify-content: center
  }
  &__choiced {
    margin-left: 7px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #757575;
  }
  &__choice-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10.625rem;
    font-size: 0.875rem;
    color: #FFFFFF;
    height: 2.375rem;
    background: #0A82D9;
    border-radius: 0.25rem;
    cursor: pointer;
    margin: 0 auto 0.875rem;
  }
  &__progress {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10.625rem;
    height: 2.375rem;
    background: #0a82d933;
    border-radius: 0.25rem;
    margin: 0 auto 1.25rem;
    position: relative;
  }
  &__progress-fill {
    background: #0A82D9;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
  }
  &__progress-text {
    font-size: 0.875rem;
    color: #212121;
    position: relative;
    z-index: 2;
  }
  &__file-loading {
    color: #757575;
    margin: 0 auto 1.875rem;
  }
}

p {
    margin-bottom: 0px;
}

.interview-switch {
  &::v-deep {
    .success--text {
      color: map-get($light-blue, 'darken-3') !important;
      caret-color: map-get($light-blue, 'darken-3') !important;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .video-uploaded {
    min-height: 23.675625rem;
    padding: 2.5rem 1.125rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
description: "If you have a recording of a call with a candidate in Zoom or Skype, you can upload the recording and it will appear in the candidate's profile"
selectFile: Select a file
changeFile: Change file
fileLoading: 'Please wait, the file is loading'
url: Link to file
cancel: Cancel
save: Save
fileSwitch: Attach file
linkSwitch: Attach a link to the file
recordSelected: Record selected
</i18n>

<i18n locale="ru" lang="yaml">
description: 'Если у вас есть запись звонка с кандидатом в Zoom или Skype, вы можете загрузить запись и она появится в карточке кандидата'
selectFile: Выбрать файл
changeFile: Изменить файл
fileLoading: 'Подождите, файл загружается'
url: Ссылка на файл
cancel: Отмена
save: Сохранить
fileSwitch: Прикрепить файл
linkSwitch: Прикрепить ссылку на файл
recordSelected: Запись выбрана
</i18n>
